<template>
    <div>
        <div class="row">
            <div class="col-sm-6">
                <home-section header="Make a claim" :footer_action="() => { $router.push({ path: 'makeaclaim' }) }">
                    <p>Please ensure that you have your Policy number and the full circumstances as we
                    will require it to process your insurance claim.</p>
                    <p>Also you will have the opportunity
                    to upload supporting documents including proof of purchase and pictures of the damage
                    which will help us process your insurance claim.</p>
                </home-section>
            </div>
            <div class="col-sm-6">
                <home-section header="Resume a claim" :footer_action="() => { $router.push({ path: 'myclaims/inprogress' }) }">
                    <p>If you have already started a claim and clicked "Save for later" you can retrieve
                    the details and complete the claim.</p>
                    <p>You will be asked to logon with the details that we will have sent you via email.</p>
                </home-section>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <home-section header="Check status of a claim" :footer_action="() => { $router.push({ path: 'myclaims' }) }">
                    <p>If you have already submitted a claim you can check on the status.</p>
                    <p>You will be asked to logon with the details that we will have sent you via email.</p>
                </home-section>
            </div>
            <div class="col-sm-6">
                <home-section header="Contact us" :footer_action="() => { $router.push({ path: 'contact' }) }">
                    <p>If you need to talk to us we can be contacted by telephone and email.</p>
                    <p>Have you tried our <a href="/#/claimsguide">help section</a>?  The answer to your question might be there.</p>
                </home-section>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HomeSection from '@/components/HomeSection.vue'

export default {
  name: 'home',
  components: {
    HomeSection
  },
  mounted() {
  },
  computed: {
      ...mapGetters({
          getReseller: 'reseller/getResellerInfo',
      }),
      leadImageExt() {
        if (this.getReseller.leadImageExt)
            return this.getReseller.leadImageExt
        else
          return `jpg`
      },
      leadImage () {
        if (this.getReseller.leadImage)
            return this.getReseller.leadImage
        else
            return 'gadgets'
      }
  }
}
</script>
